// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Payments(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Payments" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.6 4H1V17.2H18.6V4ZM9.8 13.9C11.6225 13.9 13.1 12.4225 13.1 10.6C13.1 8.77745 11.6225 7.3 9.8 7.3C7.97745 7.3 6.5 8.77745 6.5 10.6C6.5 12.4225 7.97745 13.9 9.8 13.9Z", fill: "currentColor" }),
            React.createElement("path", { d: "M20.8 7.3H23V21.6H4.3V19.4H20.8V7.3Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Payments.js.map